<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <b-col
              lg="2"
              class="my-1"
            >
              <b-form-group
                class="mb-0"
              >
                <label class="d-inline-block text-sm-left mr-50">Per page</label>
                <b-form-select
                  id="perPageSelect"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                  class="w-50"
                />
              </b-form-group>
            </b-col>

            <b-col
              lg="6"
              class="my-1"
            >
              <b-form-group
                label="Filter"
                label-cols-sm="1"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                    >
                      Clear
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <Can
              i="manage"
              a="device"
            >
              <b-col
                label-cols-sm="2"
                class="my-1"
              >
                <b-button
                  variant="success"

                  @click="$router.push('/devices/addDevice')"
                >
                  + Add Device
                </b-button>
              </b-col>
            </Can>
          </b-card-header>

          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="devices"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            :busy="isBusy"
            show-empty
            empty-text="No devices found."
            @filtered="onFiltered"
            @row-clicked="onRowClick"
          >

            <template #cell(name)="data">
              <strong>
                {{ data.item.name }}
              </strong>
            </template>

            <template #cell(deviceModel)="data">
              {{ getDeviceModelName(data.item.deviceModelDevicesId) }}
            </template>

            <template #cell(deviceManufacturer)="data">
              {{ getDeviceManufacturerName(data.item.deviceModelDevicesId) }}
            </template>

            <template #cell(site)="data">
              <div v-if="objectsMap && data.item && objectsMap[data.item.objectDevicesId] && sitesMap && objectsMap[data.item.objectDevicesId].siteObjectsId">
                <b-badge
                  variant="warning"
                  @click="$router.push(`/site/${sitesMap[objectsMap[data.item.objectDevicesId].siteObjectsId].id}`)"
                >
                  {{ sitesMap[objectsMap[data.item.objectDevicesId].siteObjectsId].name }}
                </b-badge>
              </div>
              <div
                v-else
              >
                <span class="text-muted">
                  No Site
                </span>
              </div>
            </template>

            <template #cell(object)="data">
              <div v-if="objectsMap[data.item.objectDevicesId]">
                <b-badge
                  variant="success"
                  @click="$router.push(`/object/${data.item.objectDevicesId}`)"
                >
                  {{ objectsMap[data.item.objectDevicesId].name }}
                </b-badge>
              </div>
              <div v-else>
                <span class="text-muted">
                  No Object
                </span>
              </div>
            </template>

            <template #cell(actions)="data">
              <Can
                i="manage"
                a="device"
              >
                <b-button-group>
                  <b-button
                    variant="flat-primary"
                    class="btn-icon"
                    @click="showEditModal(data)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-button
                    variant="flat-primary"
                    class="btn-icon"
                    @click="showDeleteModal(data)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </b-button-group>
              </Can>
            </template>

            <template #cell(created)="data">
              {{ new Date(`${data.item.createdAt}`).toLocaleString() }}
            </template>
          </b-table>

          <b-col
            cols="12"
            class="mb-2"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
          </b-col>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="editDeviceModal"
      ref="editDeviceModal"
      title="Edit Device"
      ok-title="Save"
      cancel-variant="outline-primary"
      ok-variant="primary"
      @ok="updateDevice"
    >
      <b-row>
        <b-col>
          <b-form-group
            label="Device Name"
            label-for="deviceName"
          >
            <b-form-input
              v-if="'name' in device"
              id="deviceName"
              ref="deviceNameInput"
              v-model="device.name"
              required
              placeholder="Enter device name"
              :state="device.name.length > 0"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Serial Number"
            label-for="serialNumber"
          >
            <b-form-input
              id="serialNumber"
              v-model="device.manufacturerSerialNumber"
              required
              placeholder="Enter serial number"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Object"
            label-for="object"
          >
            <v-select
              id="object"
              v-model="device.objectDevicesId"
              :options="objects"
              label="name"
              :reduce="object => object.id"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-if="device.objectDevicesId"
        >
          <b-form-group
            label="Position On Object"
            label-for="positionOnObject"
          >
            <b-form-input
              id="positionOnObject"
              v-model="device.positionOnObject"
              placeholder="Enter position on object"
            />
          </b-form-group>
        </b-col>
      </b-row>

    </b-modal>
  </div>

</template>

<script>
import { API } from 'aws-amplify'
import {
  BCard,
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BButtonGroup,
  BCardHeader,
  BModal,
  BBadge,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { Can } from '@casl/vue'
import vSelect from 'vue-select'
import * as queries from '../../graphql/queries'
import * as mutations from '../../graphql/mutations'

export default {
  components: {
    BCard,
    BTable,
    BCardHeader,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BBadge,
    BButton,
    BButtonGroup,
    BModal,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    Can,

  },
  data() {
    return {
      isBusy: true,
      nextId: '',
      perPage: 100,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: 'name',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'manufacturerSerialNumber', label: 'Serial Number', sortable: true },
        { key: 'deviceManufacturer', label: 'Manufacturer', sortable: true },
        { key: 'deviceModel', label: 'Model', sortable: true },
        { key: 'site', label: 'Site', sortable: true },
        { key: 'object', label: 'Object', sortable: true },
        { key: 'positionOnObject', label: 'Position On Object' },
        { key: 'created', label: 'Created', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
      devices: [],
      deviceModelsMap: {},
      device: {},
      objects: [],
      objectsMap: {},
      sites: [],
      sitesMap: {},
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  mounted() {
    // Set the initial number of devices
    this.totalRows = this.devices.length
  },
  created() {
    this.listDevices()
    this.listObjects()
    this.listSites()
  },
  methods: {
    getDeviceModelName(id) {
      const deviceModel = this.deviceModelsMap[id]
      if (deviceModel && deviceModel.name) {
        return deviceModel.name
      }
      return 'Unknown'
    },
    getDeviceManufacturerName(id) {
      const deviceModel = this.deviceModelsMap[id]
      if (deviceModel && deviceModel.name) {
        return deviceModel.deviceManufacturer.name
      }
      return 'Unknown'
    },
    triggerToast(title, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
        },
      },
      {
        position: 'bottom-right',
      })
    },
    showDeleteModal(data) {
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to delete ${data.item.name}`, {
        title: 'Please Confirm',
        size: 'md',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
      })
        .then(async value => {
          if (value === true) {
            await this.deleteDeviceFromNetwork(data.item)
            await this.deleteDeviceFromWorkspace(data.item)
            this.devices = []
            this.triggerToast(`${data.item.name} deleted`, 'success', 'DeleteIcon')
            this.listDevices()
          }
        })
    },
    showEditModal(data) {
      this.device = data.item
      this.$refs.editDeviceModal.show()
    },
    async updateDevice(event) {
      if (this.device.name.length === 0) {
        this.$refs.deviceNameInput.focus()
        event.preventDefault() // prevent modal from submitting
      } else {
      // No suppport for PUT request in API
        const deviceInfo = {
          id: this.device.id,
          name: this.device.name,
          manufacturerSerialNumber: this.device.manufacturerSerialNumber,
        }

        if (this.device.positionOnObject) {
          deviceInfo.positionOnObject = this.device.positionOnObject
        } else {
          deviceInfo.positionOnObject = null
        }

        if (this.device.objectDevicesId) {
          deviceInfo.objectDevicesId = this.device.objectDevicesId
        } else {
          deviceInfo.objectDevicesId = null
          deviceInfo.positionOnObject = null
        }

        await API.graphql({
          query: mutations.updateDevice,
          variables: {
            input: deviceInfo,
          },
        }).then(response => {
          if (!response.errors) {
            this.device = response.data.updateDevice
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: `Device 
              ${this.device.name}`
              + ' updated',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.devices = []
            this.listDevices()
          }
        })
      }
    },
    async getNetwork(networkDevicesId) {
      const response = await API.graphql({
        query: queries.getNetwork,
        variables: { id: networkDevicesId },
      })
      return response.data.getNetwork
    },
    async deleteDeviceFromNetwork(device) {
      const network = await this.getNetwork(device.networkDevicesId)
      if (network.networkType.identifier === 'tts') {
        const workspace = await JSON.parse(localStorage.getItem('workspace'))
        const workspaceId = workspace.id
        // Construct the application ID
        const applicationId = `${device.deviceModelDevicesId.substring(0, 8)}-${workspaceId.substring(0, 23)}`
        const queryStringParameters = {
          network: network.networkType.identifier,
          apiEndpoint: network.networkType.apiEndpoint,
          apiKey: network.api_key,
        }
        const body = {
          device_id: device.id,
          appId: applicationId,
        }
        try {
          await API.del('NetworkAPI', '/devices', {
            headers: {
              'Content-Type': 'application/json',
            },
            queryStringParameters,
            body,
          })
        } catch (error) {
          this.triggerToast(`${error}`, 'danger', 'DeleteIcon')
        }
      } else if (network.networkType.identifier === 'prym-chirpstack') {
        const queryStringParameters = {
          network: network.networkType.identifier,
          endpoint: network.networkType.apiEndpoint,
          apiKey: network.api_key,
          devEui: device.id,
        }

        const body = {
          device_id: device.id,
        }
        try {
          await API.del('NetworkAPI', '/devices', {
            headers: {
              'Content-Type': 'application/json',
            },
            queryStringParameters,
            body,
          })
        } catch (error) {
          this.triggerToast(`${error}`, 'danger', 'DeleteIcon')
        }
      }
    },

    async deleteDeviceFromWorkspace(device) {
      const deleteDevice = {
        id: device.id,
      }
      await API.graphql({
        query: mutations.deleteDevice,
        variables: {
          input: deleteDevice,
        },
      }).then(response => {
        if (response.error) {
          this.triggerToast(`${response.error}`, 'danger', 'DeleteIcon')
        }
      })
    },
    async listDevices(nextToken) {
      const workspace = JSON.parse(localStorage.getItem('workspace'))
      await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: workspace.id,
          nextToken,
        },
      }).then(async response => {
        if (this.devices.length === 0) {
          this.devices = response.data.getWorkspace.devices.items
        } else if (this.devices.length > 0) {
          this.devices.push(...response.data.getWorkspace.devices.items)
        }
        if (response.data.getWorkspace.devices.nextToken) {
          this.listDevices(response.data.getWorkspace.devices.nextToken)
        }
      })
      this.listDeviceModels()
    },
    async listDeviceModels() {
      const deviceModels = await API.graphql({
        query: queries.listDeviceModels,
      })
      deviceModels.data.listDeviceModels.items.forEach(deviceModel => {
        this.deviceModelsMap[deviceModel.id] = deviceModel
      })
      this.isBusy = false
    },
    async listObjects() {
      const workspace = JSON.parse(localStorage.getItem('workspace'))
      await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: workspace.id,
        },
      }).then(async response => {
        this.objects = response.data.getWorkspace.objects.items
        this.objects.forEach(object => {
          this.objectsMap[object.id] = object
        })
      })
    },
    async listSites() {
      const workspace = JSON.parse(localStorage.getItem('workspace'))
      await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: workspace.id,
        },
      }).then(async response => {
        this.sites = response.data.getWorkspace.sites.items
        this.sites.forEach(site => {
          this.sitesMap[site.id] = site
        })
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowClick(event) {
      window.location.href = `/devices/${event.id}`
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
